module.exports = __webpack_public_path__ + "img/average_check.6fac5f93.svg";